import { AttachmentDto, AttachmentListItemDto } from "../models/attachment/attachment";
import { apiCall, apiCallBlob, ApiResponse, apiUploadFiles } from "./apiClient";

export const getAttachments = (attachmentData: AttachmentDto): Promise<ApiResponse<AttachmentListItemDto[]>> => {
    return apiCall<AttachmentListItemDto[]>("attachments/files", "GET", attachmentData);
};

export const downloadAttachment = (fileId: string, attachmentData: AttachmentDto) => {
    return apiCallBlob(`attachments/files/download/${fileId}`, "GET", attachmentData);
};

export const addAttachments = (data: FormData, attachmentData: AttachmentDto): Promise<ApiResponse<void>> => {
    let url = "attachments/upload";
    if (attachmentData.relatedObjectType && attachmentData.relatedObjectId) {
        const params = new URLSearchParams();
        params.append("relatedObjectType", attachmentData.relatedObjectType);
        params.append("relatedObjectId", attachmentData.relatedObjectId);
        url += `?${params.toString()}`;
    }
    return apiUploadFiles<void>(url, "POST", data, null);
};

export const deleteAttachment = (fileId: string): Promise<ApiResponse<AttachmentListItemDto>> => {
    return apiCall<AttachmentListItemDto>(`attachments/files/delete/${fileId}`, "DELETE");
};
